"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SummatedComponent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("span", { style: props.style },
        props.summated.point - props.summated.pointAttempt * 0.1,
        "pt"))); };
exports.default = SummatedComponent;
//# sourceMappingURL=SummatedComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/UsacModifiedRedpointMultizone/SummatedComponent.js
// module id = 686
// module chunks = 0